import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__ from "../button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__calendar_mjs_d5f08e5a__ from "../calendar.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__ from "../combobox.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__input_select_mjs_a52687c4__ from "../input-select.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__popover_mjs_23af1d02__ from "../popover.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__ from "../../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__ui_debounced_input_mjs_4fd0002b__ from "../../ui/debounced-input.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__ from "date-fns";
import * as __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__ from "./filter-context.mjs";
function FilterValue({ field, filter, actions: propActions }) {
    const contextData = propActions ? null : (0, __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__.useFiltersContext)();
    const actions = propActions ?? contextData?.actions ?? {};
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "flex items-center",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterValueController, {
            field: field,
            filter: filter,
            actions: actions
        })
    });
}
function FilterValueController({ field, filter, actions: propActions }) {
    const contextData = propActions ? null : (0, __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__.useFiltersContext)();
    const actions = propActions ?? contextData?.actions ?? {};
    switch(field.type){
        case "select":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectFilterValueController, {
                field: field,
                filter: filter,
                actions: actions
            });
        case "multiSelect":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(MultiSelectFilterValueController, {
                field: field,
                filter: filter,
                actions: actions
            });
        case "input-select":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(InputSelectFilterValueController, {
                field: field,
                filter: filter,
                actions: actions
            });
        case "text":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TextFilterValueController, {
                field: field,
                filter: filter,
                actions: actions
            });
        case "number":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(NumberFilterValueController, {
                field: field,
                filter: filter,
                actions: actions
            });
        case "date":
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DateFilterValueController, {
                field: field,
                filter: filter,
                actions: actions
            });
        default:
            return null;
    }
}
function TextFilterValueController({ field, filter, actions }) {
    const value = filter.values[0] || "";
    const handleValueChange = (newValue)=>{
        actions.setFilterValue(filter.id, [
            newValue
        ]);
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "flex items-center px-2",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__ui_debounced_input_mjs_4fd0002b__.DebouncedInput, {
            type: "text",
            placeholder: field.placeholder || "Enter value...",
            value: value,
            onChange: handleValueChange,
            className: "h-5 w-32 border-0 bg-transparent p-0 text-[13px] focus-visible:ring-0 focus-visible:ring-offset-0",
            debounce: 300,
            "data-filter-value-input": true
        })
    });
}
function NumberFilterValueController({ field, filter, actions }) {
    const isBetween = "between" === filter.operator;
    const value1 = filter.values[0] || "";
    const value2 = filter.values[1] || "";
    const handleValueChange = (newValue, index = 0)=>{
        const numValue = "" === newValue ? "" : Number(newValue);
        if (isBetween) {
            const newValues = [
                ...filter.values
            ];
            newValues[index] = numValue;
            actions.setFilterValue(filter.id, newValues);
        } else actions.setFilterValue(filter.id, [
            numValue
        ]);
    };
    if (isBetween) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "flex items-center gap-1 px-2",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__ui_debounced_input_mjs_4fd0002b__.DebouncedInput, {
                type: "number",
                placeholder: "Min",
                value: value1.toString(),
                onChange: (v)=>handleValueChange(v, 0),
                className: "h-5 w-16 border-0 bg-transparent p-0 text-[13px] focus-visible:ring-0 focus-visible:ring-offset-0",
                debounce: 300
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                className: "text-[13px] text-muted-foreground",
                children: "-"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__ui_debounced_input_mjs_4fd0002b__.DebouncedInput, {
                type: "number",
                placeholder: "Max",
                value: value2.toString(),
                onChange: (v)=>handleValueChange(v, 1),
                className: "h-5 w-16 border-0 bg-transparent p-0 text-[13px] focus-visible:ring-0 focus-visible:ring-offset-0",
                debounce: 300
            })
        ]
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "flex items-center px-2",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__ui_debounced_input_mjs_4fd0002b__.DebouncedInput, {
            type: "number",
            placeholder: field.placeholder || "Enter number...",
            value: value1.toString(),
            onChange: (v)=>handleValueChange(v, 0),
            className: "h-5 w-32 border-0 bg-transparent p-0 text-[13px] focus-visible:ring-0 focus-visible:ring-offset-0",
            debounce: 300,
            "data-filter-value-input": true
        })
    });
}
function SelectFilterValueController({ field, filter, actions }) {
    const [open, setOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const [options, setOptions] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)([]);
    const [loading, setLoading] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const loadOptions = async ()=>{
            if (!field.dataProvider?.getOptions) return;
            setLoading(true);
            try {
                const result = await field.dataProvider.getOptions();
                setOptions(Array.isArray(result) ? result : []);
            } catch (error) {
                console.warn("Failed to load options for field:", field.id, error);
                setOptions([]);
            } finally{
                setLoading(false);
            }
        };
        loadOptions();
    }, [
        field
    ]);
    const selectedValues = filter.values || [];
    const isMultiOperator = "isAnyOf" === filter.operator || "isNoneOf" === filter.operator;
    const handleSelect = (optionValue)=>{
        if (isMultiOperator) {
            const newValues = selectedValues.includes(optionValue) ? selectedValues.filter((v)=>v !== optionValue) : [
                ...selectedValues,
                optionValue
            ];
            actions.setFilterValue(filter.id, newValues);
        } else {
            actions.setFilterValue(filter.id, [
                optionValue
            ]);
            setOpen(false);
        }
    };
    const displayValue = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if (0 === selectedValues.length) return "Select option...";
        if (isMultiOperator && selectedValues.length > 1) return `${selectedValues.length} selected`;
        const option = options.find((o)=>o.value === selectedValues[0]);
        return option?.label || selectedValues[0];
    }, [
        selectedValues,
        options,
        isMultiOperator
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.Combobox, {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                    variant: "ghost",
                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("h-5 w-fit justify-start active:scale-100 border-0 bg-transparent px-2 text-[13px] font-normal hover:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0", 0 === selectedValues.length ? "text-muted-foreground" : "text-foreground"),
                    "data-filter-value-trigger": true,
                    children: displayValue
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxContent, {
                className: "sm:max-w-[800px] p-0",
                align: "start",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxInput, {
                        placeholder: "Search options..."
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxEmpty, {
                        children: loading ? "Loading..." : "No options found"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxList, {
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxGroup, {
                            children: options.map((option)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__combobox_mjs_ca92397c__.ComboboxItem, {
                                    value: option.value.toString(),
                                    onSelect: ()=>handleSelect(option.value),
                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                        className: "flex items-center gap-2 w-full",
                                        children: [
                                            option.icon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                                className: "flex items-center justify-center w-4",
                                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.isValidElement)(option.icon) ? option.icon : "function" == typeof option.icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(option.icon, {
                                                    className: "size-4"
                                                }) : null
                                            }),
                                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                                className: "flex-1",
                                                children: option.label
                                            }),
                                            selectedValues.includes(option.value) && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.CheckIcon, {
                                                className: "size-4 text-brand-primary"
                                            })
                                        ]
                                    })
                                }, option.value))
                        })
                    })
                ]
            })
        ]
    });
}
function MultiSelectFilterValueController({ field, filter, actions }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectFilterValueController, {
        field: field,
        filter: filter,
        actions: actions
    });
}
function InputSelectFilterValueController({ field, filter, actions }) {
    const [options, setOptions] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)([]);
    const [loading, setLoading] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const loadOptions = async ()=>{
            if (!field.dataProvider?.getOptions) return;
            setLoading(true);
            try {
                const result = await field.dataProvider.getOptions();
                setOptions(Array.isArray(result) ? result : []);
            } catch (error) {
                console.warn("Failed to load options for field:", field.id, error);
                setOptions([]);
            } finally{
                setLoading(false);
            }
        };
        loadOptions();
    }, [
        field
    ]);
    const selectedValues = filter.values || [];
    const isContainsOperator = "contains" === filter.operator || "doesNotContain" === filter.operator;
    const handleSelect = (optionValue)=>{
        actions.setFilterValue(filter.id, [
            optionValue
        ]);
    };
    const displayValue = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if (0 === selectedValues.length) return "";
        const option = options.find((o)=>o.value === selectedValues[0]);
        return option?.label || selectedValues[0];
    }, [
        selectedValues,
        options
    ]);
    const [inputValue, setInputValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(displayValue);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        setInputValue(displayValue);
    }, [
        displayValue
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if (inputValue === displayValue) return;
        const timer = setTimeout(()=>{
            if (inputValue.trim()) actions.setFilterValue(filter.id, [
                inputValue
            ]);
            else if ("" === inputValue) actions.setFilterValue(filter.id, []);
        }, 300);
        return ()=>clearTimeout(timer);
    }, [
        inputValue,
        filter.id,
        actions,
        displayValue
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "flex items-center px-2",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__input_select_mjs_a52687c4__.InputSelectProvider, {
            hideSuggestions: isContainsOperator,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__input_select_mjs_a52687c4__.InputSelect, {
                    value: inputValue,
                    onChange: (value)=>{
                        const searchValue = "string" == typeof value ? value : value.target?.value || value;
                        setInputValue(searchValue);
                    },
                    placeholder: field.placeholder || (isContainsOperator ? "Enter text..." : "Type to search..."),
                    className: "h-5 w-32 border-0 bg-transparent p-0 text-[13px] !rounded-none focus-visible:ring-0 focus-visible:ring-offset-0",
                    "data-filter-value-input": true
                }),
                !isContainsOperator && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__input_select_mjs_a52687c4__.InputSelectContent, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__input_select_mjs_a52687c4__.InputSelectGroup, {
                        children: loading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                            className: "p-2 text-[13px] text-muted-foreground",
                            children: "Loading..."
                        }) : 0 === options.length ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                            className: "p-2 text-[13px] text-muted-foreground",
                            children: "No options found"
                        }) : options.filter((option)=>!inputValue || option.label.toLowerCase().includes(inputValue.toLowerCase()) || option.value.toString().toLowerCase().includes(inputValue.toLowerCase())).map((option)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__input_select_mjs_a52687c4__.InputSelectItem, {
                                value: option.label,
                                onSelect: ()=>{
                                    handleSelect(option.value.toString());
                                    setInputValue(option.label);
                                },
                                className: "text-[13px]",
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                    className: "flex items-center gap-2 w-full",
                                    children: [
                                        option.icon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                            className: "flex items-center justify-center w-4",
                                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.isValidElement)(option.icon) ? option.icon : "function" == typeof option.icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(option.icon, {
                                                className: "size-4"
                                            }) : null
                                        }),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                            className: "flex-1 line-clamp-1",
                                            children: option.label
                                        })
                                    ]
                                })
                            }, option.value))
                    })
                })
            ]
        })
    });
}
function DateFilterValueController({ field, filter, actions }) {
    const [open, setOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const isBetween = "between" === filter.operator;
    const parseDateValue = (value)=>{
        if (!value) return;
        if (value instanceof Date) return value;
        if ("string" == typeof value) {
            const parsed = (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.parseISO)(value);
            return (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.isValid)(parsed) ? parsed : void 0;
        }
    };
    const date1 = parseDateValue(filter.values[0]);
    const date2 = parseDateValue(filter.values[1]);
    const handleDateSelect = (date, index = 0)=>{
        if (!date) return;
        if (isBetween) {
            const newValues = [
                ...filter.values
            ];
            newValues[index] = date.toISOString();
            actions.setFilterValue(filter.id, newValues);
        } else {
            actions.setFilterValue(filter.id, [
                date.toISOString()
            ]);
            setOpen(false);
        }
    };
    const handleRangeSelect = (range)=>{
        if (!range?.from) return;
        const values = [
            range.from.toISOString()
        ];
        if (range.to) values.push(range.to.toISOString());
        actions.setFilterValue(filter.id, values);
    };
    const displayValue = (0, __WEBPACK_EXTERNAL_MODULE_react__.useMemo)(()=>{
        if (isBetween && date1 && date2) return `${(0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(date1, "MMM dd")} - ${(0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(date2, "MMM dd")}`;
        if (date1) return (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(date1, "MMM dd, yyyy");
        return "Select date...";
    }, [
        date1,
        date2,
        isBetween
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_23af1d02__.Popover, {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_23af1d02__.PopoverTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                    variant: "ghost",
                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("h-5 w-fit justify-start hover:bg-accent hover:opacity-50 border-0 bg-transparent px-2 text-[13px] font-normal hover:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0"),
                    "data-filter-value-trigger": true,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.CalendarIcon, {
                            className: "mr-1 size-3"
                        }),
                        displayValue
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_23af1d02__.PopoverContent, {
                className: "w-auto p-0",
                align: "start",
                children: isBetween ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__calendar_mjs_d5f08e5a__.Calendar, {
                    initialFocus: true,
                    mode: "range",
                    selected: {
                        from: date1,
                        to: date2
                    },
                    onSelect: handleRangeSelect,
                    numberOfMonths: 2
                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__calendar_mjs_d5f08e5a__.Calendar, {
                    initialFocus: true,
                    mode: "single",
                    selected: date1,
                    onSelect: (date)=>handleDateSelect(date, 0)
                })
            })
        ]
    });
}
export { FilterValue };
